/**
 * 404 — catch-all for missing routes. Rendered inside PublicShell so
 * the wordmark nav + footer remain available for the user to navigate
 * back. The message itself is plain centered text — no card chrome,
 * per the design ask.
 */
import { Link } from 'react-router-dom';
import { Btn, Eyebrow, Icons } from '@/components';

export function NotFoundPage() {
  return (
    <main
      style={{
        minHeight: 'calc(100vh - 220px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '48px 20px',
        gap: 18,
      }}
    >
      <Eyebrow tone="coral" letter={3}>404 · Not found</Eyebrow>
      <h1
        className="serif"
        style={{
          fontSize: 64,
          fontWeight: 500,
          letterSpacing: -1.6,
          lineHeight: 1.02,
          margin: 0,
          textWrap: 'balance' as const,
          maxWidth: 640,
        }}
      >
        That page <span style={{ fontStyle: 'italic' }}>isn't here.</span>
      </h1>
      <p style={{ fontSize: 16, color: 'var(--ink-3)', lineHeight: 1.5, maxWidth: 480, margin: 0 }}>
        The link might be old, mistyped, or the profile may have been set to private.
        Head home — there's plenty to do.
      </p>
      <div style={{ display: 'inline-flex', marginTop: 6 }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <Btn variant="primary" size="lg" icon={<Icons.arrow size={16} />}>Back to home</Btn>
        </Link>
      </div>
    </main>
  );
}
